import { useEffect } from "react";

/**
 * Reveals `[data-reveal]` elements when they enter the viewport (adds
 * class `itly-revealed`). We deliberately do NOT attach a scroll listener
 * that toggles a body-level class: doing so caused a style recalc on
 * every scroll event which produced a perceived "text blur" during
 * scrolling. Reveal detection uses IntersectionObserver, which is fully
 * off the main scroll thread.
 */
export function useScrollReveal() {
    useEffect(() => {
        if (typeof window === "undefined" || !("IntersectionObserver" in window)) return;

        const observer = new IntersectionObserver(
            (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("itly-revealed");
                        observer.unobserve(entry.target);
                    }
                }
            },
            { threshold: 0.12, rootMargin: "0px 0px -60px 0px" },
        );
        const nodes = document.querySelectorAll("[data-reveal]");
        nodes.forEach((n) => observer.observe(n));

        return () => {
            observer.disconnect();
        };
    }, []);
}
